@if (chips().length > 0) {
    @if (label() !== '') {
        <span class="pulse-filter-chips__label">{{ label() }}</span>
    }

    <ul class="pulse-filter-chips__list">
        @for (chip of shownChips(); track chip.id) {
            <li>
                <pulse-chip
                    [label]="chip.label"
                    [removable]="removable()"
                    [removeLabel]="chip.removeLabel ?? ''"
                    (removed)="removed.emit(chip.id)"
                />
            </li>
        }
    </ul>

    @if (hiddenCount() > 0) {
        <span class="pulse-filter-chips__more">{{
            'PulseChips.More' | translate: { count: hiddenCount() }
        }}</span>
    }
}
